import { render, staticRenderFns } from "./GBoothTemplateList.vue?vue&type=template&id=6c53d9be&scoped=true&"
import script from "./GBoothTemplateList.vue?vue&type=script&lang=ts&"
export * from "./GBoothTemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothTemplateList.vue?vue&type=style&index=0&id=6c53d9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53d9be",
  null
  
)

export default component.exports